/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import { checkOptinAvailabilityRpc, setHubLevelOverrideRpc, updateTargetStateRpc } from 'ui-addon-opt/__generated__/chirp/com/hubspot/optins/rpc/OptinsAvailabilityRpc';
import { chirpClient } from 'ui-addon-opt/utils/chirpClient';
import { getUserInfo } from './UserInfoAPI';
const withOptinView = availability => Object.assign({}, availability, {
  optinView: availability.state === 'OPTED_IN' ? 'NEW' : 'CURRENT'
});
export const fetchOptinAvailability = optinName => chirpClient.call(checkOptinAvailabilityRpc, {
  request: {
    optinName
  },
  earlyRequestName: `optin-${optinName}`
}).then(({
  availability
}) => withOptinView(availability));
export const fetchUserOptSettings = optinName => Promise.all([getUserInfo().then(({
  user
}) => user), fetchOptinAvailability(optinName)]).then(([user, availability]) => ({
  availability,
  user
}));
export const updateOpt = ({
  availability: {
    stateActionAt
  },
  optinName,
  hubOverride,
  newOptinState
}) => {
  const request = {
    optinName,
    newState: newOptinState,
    currentActionAt: stateActionAt
  };
  return hubOverride ? chirpClient.call(setHubLevelOverrideRpc, {
    request
  }) : chirpClient.call(updateTargetStateRpc, {
    request
  });
};